/**
 * @param {string} locale
 * @returns {Intl.PluralRules}
 */
export function getPluralRules(locale) {
    try {
        return new Intl.PluralRules(locale || "en")
    } catch {
        return new Intl.PluralRules("en")
    }
}

/**
 * @param {unknown} n
 * @returns {number}
 */
export function toPluralNumber(n) {
    const x = Number(n)
    return Number.isFinite(x) ? x : 0
}

/**
 * @param {string} locale
 * @param {unknown} value
 * @param {object} [opts]
 * @returns {string}
 */
export function formatNumberValue(locale, value, opts) {
    const n = Number(value)
    if (!Number.isFinite(n)) return String(value ?? "")
    try {
        return new Intl.NumberFormat(locale || "en", opts).format(n)
    } catch {
        return String(n)
    }
}

/**
 * @param {string} locale
 * @param {unknown} value
 * @param {object} [opts]
 * @returns {string}
 */
export function formatDateValue(locale, value, opts) {
    const d = value instanceof Date ? value : value ? new Date(value) : null
    if (!d || Number.isNaN(d.getTime())) return String(value ?? "")
    try {
        return new Intl.DateTimeFormat(locale || "en", opts).format(d)
    } catch {
        return d.toISOString()
    }
}
